import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import './StatsPage.css';

interface StatsPageState {
  balance: number;
}

class StatsPage extends React.Component<{} , StatsPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      balance: 0
    }
    this.onReset = this.onReset.bind(this);
  }

  componentDidMount(): void {
    let cookie = Server.user.getCookie('DollarsSpent');
    let creditCardBalance = cookie ? (+cookie * -1) : 0;
    this.setState({balance: creditCardBalance});
  }

  onReset() {
    Server.user.setCookie('DollarsSpent', '0');
    this.setState({balance: 0});
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;
      
    let ccb = this.state.balance.toFixed(2);
    if(ccb.substring(0, 1) == '-')
      ccb = '-$' + ccb.substring(1);
    else
      ccb = '$' + ccb;

    return (
      <div className="stats-page">
        <div className="stats-section">
          <div className="stats-section-row">
            <div>Fake CC Balance</div>
            <div style={{textAlign: 'right', marginRight: '8px'}}>{ccb}</div>
          </div>
        </div>
        <div style={{textAlign: 'center', paddingTop: '20px'}}>
          <button onClick={this.onReset}>Reset</button>
        </div>
      </div>
    )
  }
}

export default StatsPage;